import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Steps, Button, message, Modal } from 'antd';
import DateSelection from '../../components/Booking/DateSelection/DateSelection';
import AddTickets from '../../components/Booking/AddTickets/AddTickets';
import AddMeals from '../../components/Booking/AddMeals/AddMeals';
import AddBilling from '../../components/Booking/AddBilling/AddBilling';
import AddMerchandise from '../../components/Booking/AddMerchandise/AddMerchandise';
import BookingHeader from '../../components/Booking/BookingHeader/BookingHeader';
import NewsAndUpdates from '../../components/homepage/NewsAndUpdates/NewsAndUpdates';
import BookingSummary from '../../components/Booking/BookingSummary/BookingSummary';
import './BookingPage.css';
import { ArrowRightOutlined, CloseOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import useCoupons from '../../hooks/common/useCoupon';
import useRetail from '../../hooks/useRetail';
import useAccountFlow from '../../hooks/common/useAccountFlow';
import { useData } from '../../context/DataContext';
import dayjs from 'dayjs';

const steps = [
  { title: 'Select Date' },
  { title: 'Add Tickets' },
  { title: 'Add Meals' },
  { title: 'Add Merchandise' },
  { title: 'Add Info' }
];

const BookingPage = () => {
  const navigate = useNavigate();
  const { getCouponById } = useCoupons();
  const { accountDetails } = useAccountFlow();
  const { disabled, tooltipMessage } = useData();
  const { createBooking, isBooking, createPaymentLink } = useRetail();
  const [bookingDate, setBookingDate] = useState('');
  const [currentStep, setCurrentStep] = useState(0);
  const [updatedBookingDetails, setUpdatedBookingDetails] = useState({});
  const [updatedFoodDetails, setUpdatedFoodDetails] = useState({});
  const [updatedMerchandise, setUpdatedMerchandise] = useState({});
  const [updatedBillingDetails, setUpdatedBillingDetails] = useState({});
  const [bookingSummaryData, setBookingSummaryData] = useState({});
  const [couponDetails, setCouponDetails] = useState();
  const [discountAmount, setDiscountAmount] = useState(0);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 992);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 575);
  const [isCouponHasError, setIsCouponHasError] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 575);
      setIsDesktop(window.innerWidth >= 991);
    };
    setIsModalOpen(true)
    window.scrollTo({ top: 0, behavior: 'instant' });
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if(tooltipMessage) {
      message.info(tooltipMessage)
      navigate('/home')
    }
  }, [navigate, tooltipMessage]);

  const handleDateSelect = (date) => {
    setBookingDate(date);
    console.log(date)
  };

  // const next = () => {
  //   setCurrentStep((prev) => prev + 1);
  // };

  // const prev = () => {
  //   setCurrentStep((prev) => prev - 1);
  // };
  useEffect(() => {
    if (isMobile) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [currentStep]);
  
  const next = () => {
    if(currentStep === 0) {
      if(!bookingDate) {
        return message.error("Please select the Date")
      }
    }
    if(currentStep === 1) {
      if (couponDetails?.minTickets) {  
        const minTickets = couponDetails.minTickets;
        if (updatedBookingDetails.totalTicketCount < minTickets) {
          message.error(`This coupon requires a minimum of ${minTickets} tickets.`);
          return;
        }
      }
      if(isCouponHasError) {
        const startDate = couponDetails?.startDate || null;
        const start = couponDetails.startDate ? dayjs(Number(couponDetails.startDate)) : null;
        const end = couponDetails.endDate ? dayjs(Number(couponDetails.endDate)) : null;
        const booking = dayjs(bookingDate, "DD/MM/YY");

        if (couponDetails.couponCode === "JOYNRPGT20" && start && end) {
          const isOutOfRange = booking.isBefore(start, "day") || booking.isAfter(end, "day");
          if (isOutOfRange) return message.error(`This coupon is only valid between ${start.format("DD/MM/YYYY")} and ${end.format("DD/MM/YYYY")}`);
        }
        return message.error(`This coupon will only be available after ${dayjs(Number(startDate)).format('DD/MM/YYYY')}`)
      }
      if(!updatedBookingDetails.totalTicketCount || updatedBookingDetails.totalTicketCount <= 0) {
        return message.error("Please select minimum one ticket")
      }
    }
      setCurrentStep((prevStep) => prevStep + 1);
  };
  
  const prev = () => {
    setCurrentStep((prevStep) => Math.max(prevStep - 1, 0));
  };  

  const totalAmount =  
        (updatedBookingDetails?.ticketTotal || 0) + 
        (updatedFoodDetails?.foodTotal || 0) + 
        (updatedMerchandise?.merchandiseTotal || 0);
  
  useEffect(() => {
    if (updatedBookingDetails?.couponCode) {
      getCouponById(updatedBookingDetails.couponCode)
        .then((data) => {
          setCouponDetails(data);
  
          if (data?.percentage && data?.count) {
            const discount = Math.round((totalAmount * data.percentage) / 100);
            setDiscountAmount(discount);
          } else {
            setDiscountAmount(0);
          }
        })
        .catch(() => {
          setCouponDetails(null);
          setDiscountAmount(0);
        });
    }
  }, [updatedBookingDetails?.couponCode, totalAmount]); 

  const totalPayable = Math.round(totalAmount - discountAmount);  
  const gstAmount = Math.round((totalPayable * 18) / 118);
  const gstPercentage = 18
  const beforeTax =  (totalPayable / (1 + gstPercentage / 100)).toFixed(0);
  
  const isSubscription = accountDetails?.customer?.isSubscription ?? false;
  const isSubscriptionBooking = isSubscription ? true : false;

  const handleContinue = async () => {
    try {
      const fieldLabels = {
        fullName: "Full Name",
        phoneNumber: "Phone Number",
        email: "Email Address",
        pincode: "Pincode",
        // bookingDate: "Booking Date",
        // totalTicketCount: "Minimum 1 Ticket",
      };
  
      let missingFields = [];
  
      if (!updatedBillingDetails.fullName) missingFields.push(fieldLabels.fullName);
      if (!updatedBillingDetails.phoneNumber) missingFields.push(fieldLabels.phoneNumber);
      if (!updatedBillingDetails.email) missingFields.push(fieldLabels.email);
      if (!updatedBillingDetails.pincode) missingFields.push(fieldLabels.pincode);
      // if (!bookingDate) missingFields.push(fieldLabels.bookingDate);
      // if (!updatedBookingDetails.totalTicketCount || updatedBookingDetails.totalTicketCount <= 0) {
      //   missingFields.push(fieldLabels.totalTicketCount);
      // }

      if (missingFields.length > 0) {
        message.error(`Please fill all required fields: ${missingFields.join(", ")}`);
        return;
      }

      if (couponDetails?.minTickets) {  
        const minTickets = couponDetails.minTickets;
        if (updatedBookingDetails.totalTicketCount < minTickets) {
          message.error(`This coupon requires a minimum of ${minTickets} tickets.`);
          return;
        }
      }        
  
      const bookingDetails = {
        bookingDate,
        adult: updatedBookingDetails.adult,
        child: updatedBookingDetails.child,
        senior: updatedBookingDetails.senior,
        disabled: updatedBookingDetails.disabled,
        totalTicketCount: updatedBookingDetails.totalTicketCount,
        totalAmount: updatedBookingDetails.ticketTotal,
        ticketPrices: updatedBookingDetails.ticketPrices,
        couponCode: updatedBookingDetails.couponCode,
        gstNo: updatedBookingDetails.gstNo,
  
        foodCount: updatedFoodDetails.foodCount,
        food: updatedFoodDetails.food,
        foodTotal: updatedFoodDetails.foodTotal,
  
        merchandise: updatedMerchandise.merchandise,
        merchandiseCount: updatedMerchandise.merchandiseCount,
        merchandiseTotal: updatedMerchandise.merchandiseTotal,
  
        fullName: updatedBillingDetails.fullName,
        phoneNumber: updatedBillingDetails.phoneNumber,
        email: updatedBillingDetails.email,
        pincode: updatedBillingDetails.pincode,
  
        gstAmount,
        discountAmount,
        beforeTax,
        isSubscriptionBooking,
        totalPayable,
      };
  
      const response = await createBooking(bookingDetails);
  
      if (!response || !response._id) {
        message.error("Booking failed. Please try again.");
        return;
      }
  
      if (response?.payment_status === "success") {
        navigate(`/paymentsuccess/${response._id}`);
        return;
      }
  
      if (response?.payment_status !== "success") {
        const paymentLink = await createPaymentLink(response._id);
  
        if (paymentLink) {
          window.location.href = paymentLink;
        } else {
          message.error("Failed to create payment link.");
        }
      }
    } catch (error) {
      console.error("Booking Error:", error);
      message.error("Please fill all required fields correctly!");
    }
  };
  
  return (
    <>
      <BookingHeader />

      <Container className='pb-5'>
        <Row className='d-flex align-items-center justify-content-center'>
          <Col xxl={10} xl={10} lg={10} md={12} sm={12} xs={12}>
            <Steps
              current={currentStep}
              className="custom-steps"
              items={
                isMobile
                  ? [
                      {
                        title: (
                          <>
                            <p className="step-title mb-0 text-start">{steps[currentStep].title}</p>
                            <p className="step-count mb-2 text-start">Step {currentStep + 1}/{steps.length}</p>
                          </>
                        ),
                        icon: (
                          <span className="custom-step-icon fs-16 text-white">
                            {currentStep + 1}
                          </span>
                        ),
                      },
                    ]
                  : steps.map((step, index) => ({
                      title: step.title,
                      icon: (
                        <span className="custom-step-icon fs-16 text-white">
                          {index + 1}
                        </span>
                      ),
                    }))
              }
            />

            <Row className='d-flex'>
              <Col xxl={7} xl={7} lg={7} md={12} sm={12} xs={12}>
                {currentStep === 0 && <DateSelection onDateSelect={handleDateSelect} />}
                {currentStep === 1 && (
                  <AddTickets 
                    setUpdatedBookingDetails={setUpdatedBookingDetails} 
                    bookingDate={bookingDate} 
                    setIsCouponHasError={setIsCouponHasError}
                  />
                )}
                {currentStep === 2 && <AddMeals setUpdatedFoodDetails={setUpdatedFoodDetails} />}
                {currentStep === 3 && <AddMerchandise setUpdatedMerchandise={setUpdatedMerchandise} />}
                {currentStep === 4 && <AddBilling setUpdatedBillingDetails={setUpdatedBillingDetails} />}

                <div className='submit-web' style={{ marginTop: 24, display: 'flex', justifyContent: 'space-between' }}>
                  {currentStep > 0 && (
                    <Button 
                      type='default'
                      size='large'
                      className='fs-16 fw-700 booking-btn'
                      style={{borderColor: 'black'}}
                      onClick={prev} 
                    >
                      Back
                    </Button>
                  )}
                  {currentStep < steps.length - 1 ? (
                    <Button 
                      type="primary" 
                      size='large'
                      className="fs-16 fw-700 booking-btn"
                      onClick={next}
                    >
                      Continue
                      <span><ArrowRightOutlined/></span>
                    </Button>
                  ) : (
                    <Button 
                      type="primary" 
                      size='large'
                      className="fs-16 fw-700 booking-btn"
                      onClick={handleContinue}
                      loading={isBooking}
                    >
                        Proceed to Pay <span><ArrowRightOutlined/></span>                   
                    </Button>
                  )}
                </div>
              </Col>

              <Col 
                xxl={5} xl={5} lg={5} md={12} sm={12} xs={12}
                className='booking-summary-container d-none d-sm-block'
              >
                <BookingSummary
                  bookingDate={bookingDate}
                  updatedBookingDetails={updatedBookingDetails}
                  updatedFoodDetails={updatedFoodDetails}
                  updatedMerchandise={updatedMerchandise}
                  updatedBillingDetails={updatedBillingDetails}
                  bookingSummaryData={bookingSummaryData}
                />
              </Col>

              {currentStep === 4 && (
                <div className='d-block d-sm-none mt-4'>
                  <BookingSummary
                    bookingDate={bookingDate}
                    updatedBookingDetails={updatedBookingDetails}
                    updatedFoodDetails={updatedFoodDetails}
                    updatedMerchandise={updatedMerchandise}
                    updatedBillingDetails={updatedBillingDetails}
                    bookingSummaryData={bookingSummaryData}
                  />
                </div>
              )}

              {/* <Col xxl={5} xl={5} lg={5} md={12} sm={12} xs={12} className='booking-summary-container'>
                <BookingSummary
                  bookingDate={bookingDate}
                  updatedBookingDetails={updatedBookingDetails}
                  updatedFoodDetails={updatedFoodDetails}
                  updatedMerchandise={updatedMerchandise}
                  updatedBillingDetails={updatedBillingDetails}
                  bookingSummaryData={bookingSummaryData}
                />
              </Col> */}
            </Row>
            <Row className='submit-mob'>
              <Col md={6} sm={12} xs={12}>
                {currentStep > 0 && (
                  <Button 
                    type='default'
                    size='large'
                    className='fs-16 fw-700 booking-btn w-100 mt-3'
                    style={{borderColor: 'black'}}
                    onClick={prev} 
                  >
                    Back
                  </Button>
                )}
              </Col>
              <Col md={6} sm={12} xs={12}>
                {currentStep < steps.length - 1 ? (
                  <Button 
                    type="primary" 
                    size='large'
                    className="fs-16 fw-700 booking-btn w-100 mt-3"
                    onClick={next}
                  >
                    Continue
                    <span><ArrowRightOutlined/></span>
                  </Button>
                ) : (
                  <Button 
                    type="primary" 
                    size='large'
                    className="fs-16 fw-700 booking-btn w-100 mt-3"
                    onClick={handleContinue}
                    loading={isBooking}
                  >
                      Proceed to Pay <span><ArrowRightOutlined/></span>                   
                  </Button>
                )}
              </Col>
            </Row>
        </Col>
       </Row>
      </Container>
      
      <NewsAndUpdates />

      <Modal
        open={isModalOpen}
        title={
          <div className='mdl-header mb-3'>
            <div className='fs-24 cursor-pointer text-end d-flex justify-content-between align-items-center'>
              <span className="d-flex align-items-center">
                <ExclamationCircleOutlined
                  style={{
                    color: 'white',
                    fontSize: 44,
                    marginRight: 12,
                    backgroundColor: '#faad14',
                    borderRadius: '50%',
                  }}
                />
              </span>
              <CloseOutlined onClick={() => setIsModalOpen(false)} />
            </div>
          </div>
        }
        footer={null}
        centered
        closable={false}
        maskClosable={true}
        onCancel={() => setIsModalOpen(false)}
      >
        <div style={{ fontSize: 16, lineHeight: 1.7 }}>
          <span className='fw-bold fs-18'>Monsoon Advisory – Please Read Before You Visit!</span>
          <p><strong>Dear Guests,</strong></p>
          <p>With early monsoon showers setting in, park operations may be affected. Please take note of the following important updates:</p>
          <ol style={{ paddingLeft: 20 }}>
            <li>Call us at <strong>+91 9739777566</strong> before booking or visiting to confirm park status.</li>
            <li>We aim to keep the gates <strong>OPEN on weekdays</strong>, weather permitting. Park will remain <strong>OPEN on weekends</strong> irrespective of rains.</li>
            <li><strong>Online ticket holders</strong> can reschedule to future dates <strong>at no extra cost</strong>.</li>
            <li>Park operations may vary (fully open, partially operational, or closed) based on real-time weather.</li>
          </ol>
          <p>🌟 <strong>Your safety and comfort are our top priorities.</strong></p>
          <p>Stay tuned to our website and social media for daily updates.</p>
          <p><strong>Thank you for your support and understanding – let’s make the most of this joyful season!</strong></p>
        </div>
      </Modal>
    </>
  );
};

export default BookingPage;
